import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1,
  Paragraph,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Ale">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Mørk Ale</Heading1>
        </Col>
        <Col md={12} paddingTop="0px">
          <Paragraph>
            En mørk ale har som oftest en blød, rund og fyldig smag, mens den også har tendens til en kraftig sødme. Denne ale har en humlet og intens aroma, der suppleres af karakterer af både nødder og tørrede frugter.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelDarkAle" filterLiterSize display={ProductView1} />
      </RowProductView>
    </Container>
  </SidemenuLayout>
);
